import React from 'react';

const OnboardingHeading = ({ pageHeading }) => {
    return (
        <div className="col-12">
            <h1 className="onboarding-layout__page-heading">{pageHeading}</h1>
        </div>
    );
}

export default OnboardingHeading;

